import type { FunctionComponent } from "react";

import { ComingSoonPage } from "../pages/ComingSoon";
import { FEATURES, type FeatureKey } from "./features";

// Route-level enforcement of the feature gate (ADR 0025 D2). A built-but-gated
// route renders its real component only when the flag is on; when off it renders
// ComingSoonPage, so typing the URL directly cannot bypass the gate. Pairs with
// the entry-point hiding in the nav/toolbar (ADR 0025 D3).
export function requireFeature(
  key: FeatureKey,
  Enabled: FunctionComponent,
  feature: string,
): FunctionComponent {
  if (FEATURES[key].enabled) return Enabled;
  const plannedUnit = FEATURES[key].plannedUnit ?? "post-launch";
  function GatedFeature() {
    return <ComingSoonPage feature={feature} plannedUnit={plannedUnit} />;
  }
  GatedFeature.displayName = `GatedFeature(${feature})`;
  return GatedFeature;
}
